export enum LenderLanguage {
    EN = "en",
    FR = "fr"
}
